module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation-desktop"
  }, [_c('div', {
    staticClass: "navigation-desktop__top"
  }, [_c('div', {
    staticClass: "navigation-desktop__container"
  }, [(_vm.content) ? _c('div', {
    staticClass: "navigation-desktop__icons"
  }, [_c('a', {
    staticClass: "navigation-desktop__icon",
    attrs: {
      "href": _vm.content.acf.navigation.map_link,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "locations"
    }
  })], 1), _c('a', {
    staticClass: "navigation-desktop__icon",
    attrs: {
      "href": _vm.content.acf.navigation.phone_link,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "white_phone"
    }
  })], 1), _c('a', {
    staticClass: "navigation-desktop__icon",
    attrs: {
      "href": _vm.content.acf.navigation.facebook_link,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "thumbs_up"
    }
  })], 1)]) : _vm._e()])]), _c('div', {
    staticClass: "navigation-desktop__bottom"
  }, [_c('div', {
    staticClass: "navigation-desktop__container--flexed"
  }, [_c('div', {
    staticClass: "navigation-desktop__logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "full_logo"
    }
  })], 1)], 1), _c('div', {
    staticClass: "navigation-desktop__links"
  }, _vm._l((_vm.props), function(link) {
    return (link.navigation) ? _c('div', {
      staticClass: "navigation-desktop__link"
    }, [_c('router-link', {
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name))])], 1) : _vm._e()
  })), (_vm.content) ? _c('div', {
    staticClass: "navigation-desktop__appointment",
    on: {
      "click": function($event) {
        _vm.modal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.content.acf.navigation.button_text))]) : _vm._e()])]), _c('ModalRequestAppointment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modal),
      expression: "modal"
    }],
    on: {
      "close": function($event) {
        _vm.modal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d755962e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-desktop/navigation-desktop.pug
// module id = 554
// module chunks = 1